import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AddWatchman = () => {
    const [name, setName] = useState('');
    const [contactNo, setContactNo] = useState('');
    const [purpose, setPurpose] = useState('');
    const [time, setTime] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Set current datetime in correct format
    useEffect(() => {
        const now = new Date();
        const formatted = now.toISOString().slice(0, 16); // yyyy-MM-ddThh:mm
        setTime(formatted);
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!name || !contactNo || !purpose || !time) {
            setError('All fields are required!');
            return;
        }
    
        const formattedTime = new Date(time).toISOString().slice(0, 19).replace('T', ' '); // yyyy-MM-dd HH:mm:ss
        const payload = {
            name,
            contact_no: contactNo,
            purpose,
            time: formattedTime,
            staff_id: 1 // TEMP STATIC — replace this with dynamic value if needed
        };
        
        try {
            const res = await fetch('http://pbhrm.com/api/watchman', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
    
            const data = await res.json();
    
            if (data.status === 1) {
                alert('Watchman added successfully');
                navigate('/WatchmenList');
            } else {
                setError(data.message || 'Failed to add watchman.');
            }
        } catch (err) {
            console.error(err);
            setError('There was an error connecting to the server.');
        }
    };
    
    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Entry</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add Entry</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="contactNo" className="form-label">Contact Number</label>
                                        <input
                                            type="text"
                                            id="contactNo"
                                            className="form-control"
                                            value={contactNo}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setContactNo(value);
                                                }
                                            }}
                                            required
                                            maxLength={10}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="purpose" className="form-label">Purpose</label>
                                        <input
                                            type="text"
                                            id="purpose"
                                            className="form-control"
                                            value={purpose}
                                            onChange={(e) => setPurpose(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3 d-none">
                                        <label htmlFor="time" className="form-label">Time</label>
                                        <input
                                            type="datetime-local"
                                            id="time"
                                            className="form-control"
                                            value={time}
                                            onChange={(e) => setTime(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Add Entry</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddWatchman;
